import { Logger } from '../../types/loggerTypes';
import SilentLogger from '../../../client/logger/silentLogger';
import { DataLayerManagerInterface } from './abstractDataLayerManager';
import { DataLayerPlatform } from './serverDataLayerManager';
import { ClientDataLayerManager, ServerDataLayerManager } from './index';
import AppsDataLayerManager from 'Common/ga/dataLayerManager/appsDataLayerManager';

export type DataLayerManagerFactoryGetter = (logger: Logger) => DataLayerManagerInterface;
export type DataLayerManagerFactoryRegister = Record<DataLayerManagerType, DataLayerManagerFactoryGetter>;
export enum DataLayerManagerType {
    SERVER = 'SERVER',
    CLIENT = 'CLIENT',
    APPS = 'APPS',
    MOCK = 'MOCK',
    CLIENT_WITH_NO_DELAY = 'CLIENT_WITH_NO_DELAY',
}

const registeredFactories: DataLayerManagerFactoryRegister = {
    CLIENT: logger => new ClientDataLayerManager(logger),
    CLIENT_WITH_NO_DELAY: logger =>
        new (class ClientHeader extends ClientDataLayerManager {
            public constructor(loggerInstance: Logger) {
                super(loggerInstance);
                this.userSessionDidInit = true;
            }
        })(logger),

    SERVER: logger => new ServerDataLayerManager(logger),
    MOCK: logger => new ClientDataLayerManager(logger),
    APPS: logger => new AppsDataLayerManager(logger),
};

interface DataLayerManagerFactoryProps {
    logger?: Logger;
    type: DataLayerManagerType;
    platform: DataLayerPlatform;
}

export class DataLayerManagerFactory {
    public static createDataLayerManager({
        logger = SilentLogger.createInstance(),
        platform,
        type,
    }: DataLayerManagerFactoryProps): DataLayerManagerInterface {
        const dl = registeredFactories[type](logger);
        dl.setPlatform(platform);
        return dl;
    }
}
